/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsWebPushOptions interface.
 */
export function instanceOfFxIdDomainSettingsWebPushOptions(value) {
    if (!('VapidPublicKey' in value) || value['VapidPublicKey'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsWebPushOptionsFromJSON(json) {
    return FxIdDomainSettingsWebPushOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsWebPushOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'VapidPublicKey': json['VapidPublicKey'],
    };
}
export function FxIdDomainSettingsWebPushOptionsToJSON(json) {
    return FxIdDomainSettingsWebPushOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsWebPushOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'VapidPublicKey': value['VapidPublicKey'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsWebPushOptions.js.map